export const TOGGLE_MENU = "TOGGLE_MENU"

export const GRAPHQL_REQUEST_ACTIVE_MODULES = "GRAPHQL_REQUEST_ACTIVE_MODULES"